import React from 'react';
import { styled } from '@compiled/react';
import Icon from '@atlaskit/icon';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { ServicesGlyph } from '@atlassian/jira-servicedesk-work-category/src/common/assets/glyph.tsx';
import type { OptionRenderProps, ServiceDetails } from '../../common/types/index.tsx';

type OptionContentProps = OptionRenderProps<ServiceDetails>;

type OptionContentInnerProps = {
	label: string;
	innerProps?: OptionContentProps['innerProps'];
};

/** Split into an inner component for simpler storybook examples */
export const OptionContentInner = (props: OptionContentInnerProps): React.JSX.Element => {
	const { innerProps, label } = props;
	return (
		<Outer {...innerProps}>
			{/* eslint-disable-next-line @atlaskit/design-system/no-custom-icons */}
			<Icon
				// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => JSX.Element' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'. */}
				glyph={ServicesGlyph}
				label={label}
			/>
			<Box xcss={innerStyles}>{label}</Box>
		</Outer>
	);
};

export const OptionContent = (props: OptionContentProps): React.JSX.Element => {
	const {
		innerProps,
		data: { label },
	} = props;

	return <OptionContentInner innerProps={innerProps} label={label} />;
};

// TODO: https://product-fabric.atlassian.net/browse/DSP-858

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Outer = styled.div({
	display: 'flex',
	alignItems: 'center',
	paddingTop: token('space.100'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.200'),
	'&:hover': {
		backgroundColor: token('color.background.neutral.subtle.hovered'),
	},
});

const innerStyles = xcss({
	paddingLeft: 'space.100',
});
